import React from 'react'

const Claim = () => {
  return (
    <svg
      width="170"
      height="50"
      viewBox="0 0 170 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_343_1914)">
        <rect width="170" height="50" rx="25" fill="#33CC66" />
      </g>
      <path
        d="M73.94 32.28C71.8467 32.28 70.1067 31.58 68.72 30.18C67.3467 28.7933 66.66 27.0667 66.66 25C66.66 22.92 67.3467 21.1933 68.72 19.82C70.1067 18.42 71.8467 17.72 73.94 17.72C75.2067 17.72 76.3733 18.02 77.44 18.62C78.52 19.2067 79.36 20.0067 79.96 21.02L77.58 22.4C77.2333 21.7733 76.74 21.2867 76.1 20.94C75.46 20.58 74.74 20.4 73.94 20.4C72.58 20.4 71.48 20.8267 70.64 21.68C69.8133 22.5467 69.4 23.6533 69.4 25C69.4 26.3333 69.8133 27.4333 70.64 28.3C71.48 29.1533 72.58 29.58 73.94 29.58C74.74 29.58 75.46 29.4067 76.1 29.06C76.7533 28.7 77.2467 28.2133 77.58 27.6L79.96 28.98C79.36 29.9933 78.52 30.8 77.44 31.4C76.3733 31.9867 75.2067 32.28 73.94 32.28ZM84.2717 32H81.6917V17.4H84.2717V32ZM94.2331 23.18V22H96.8131V32H94.2331V30.82C93.4598 31.7933 92.3731 32.28 90.9731 32.28C89.6398 32.28 88.4931 31.7733 87.5331 30.76C86.5865 29.7333 86.1131 28.48 86.1131 27C86.1131 25.5333 86.5865 24.2867 87.5331 23.26C88.4931 22.2333 89.6398 21.72 90.9731 21.72C92.3731 21.72 93.4598 22.2067 94.2331 23.18ZM89.4731 29.04C89.9931 29.56 90.6531 29.82 91.4531 29.82C92.2531 29.82 92.9131 29.56 93.4331 29.04C93.9665 28.5067 94.2331 27.8267 94.2331 27C94.2331 26.1733 93.9665 25.5 93.4331 24.98C92.9131 24.4467 92.2531 24.18 91.4531 24.18C90.6531 24.18 89.9931 24.4467 89.4731 24.98C88.9531 25.5 88.6931 26.1733 88.6931 27C88.6931 27.8267 88.9531 28.5067 89.4731 29.04ZM100.433 20.8C100.006 20.8 99.6327 20.6467 99.3127 20.34C99.006 20.02 98.8527 19.6467 98.8527 19.22C98.8527 18.7933 99.006 18.42 99.3127 18.1C99.6327 17.78 100.006 17.62 100.433 17.62C100.873 17.62 101.246 17.78 101.553 18.1C101.873 18.42 102.033 18.7933 102.033 19.22C102.033 19.6467 101.873 20.02 101.553 20.34C101.246 20.6467 100.873 20.8 100.433 20.8ZM101.733 32H99.1527V22H101.733V32ZM115.154 21.72C116.301 21.72 117.214 22.0933 117.894 22.84C118.587 23.5867 118.934 24.5867 118.934 25.84V32H116.354V26.02C116.354 25.42 116.207 24.9533 115.914 24.62C115.621 24.2867 115.207 24.12 114.674 24.12C114.087 24.12 113.627 24.3133 113.294 24.7C112.974 25.0867 112.814 25.6467 112.814 26.38V32H110.234V26.02C110.234 25.42 110.087 24.9533 109.794 24.62C109.501 24.2867 109.087 24.12 108.554 24.12C107.981 24.12 107.521 24.32 107.174 24.72C106.841 25.1067 106.674 25.66 106.674 26.38V32H104.094V22H106.674V23.06C107.274 22.1667 108.201 21.72 109.454 21.72C110.694 21.72 111.601 22.2 112.174 23.16C112.827 22.2 113.821 21.72 115.154 21.72Z"
        fill="white"
      />
      <path
        d="M26 10C34.28 10 41 16.72 41 25C41 33.28 34.28 40 26 40C17.72 40 11 33.28 11 25C11 16.72 17.72 10 26 10ZM27.5 25V19H24.5V25H20L26 31L32 25H27.5Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_b_343_1914"
          x="-7.6"
          y="-7.6"
          width="185.2"
          height="65.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3.8" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_343_1914"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_343_1914"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Claim
